import styled from "@emotion/styled";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { RemoveInputStyles } from "../../../../components/GeneralStyles";
import { rem, theme } from "../../../../styling/theme";
import { FieldTypeT } from "../../data-access/types";
import { useMutateMedia } from "../../hooks/useMutateMedia";
import InsightItemWrapper from "../../ui/InsightItemWrapper";

const StyledInput = styled.input({
  ...RemoveInputStyles,
  padding: 0,
  margin: 0,
  fontSize: rem(15),
  fontWeight: 600,
  color: theme.color.textColor,
  zIndex: 1,
});

type InputColumnT = {
  id: number;
  inputKey: FieldTypeT;
  participantId: string;
  label: string;
  value: number | null;
  permanentDisabled?: boolean;
  liveAddedMedia?: boolean;
};

const InputColumn: React.FC<InputColumnT> = ({
  id,
  inputKey,
  participantId,
  label,
  value,
  permanentDisabled = false,
  liveAddedMedia,
}) => {
  const [firstLoad, setFirstLoad] = useState(true);
  const [focus, setFocus] = useState(false);
  const [valueState, setValueState] = useState<number | null>(value || null);
  const { disabled, mutateMedia } = useMutateMedia(
    id,
    inputKey,
    participantId,
    undefined,
    liveAddedMedia ? "addedMediaGroups" : "mediaGroups"
  );

  const input = useRef<HTMLInputElement>(null);

  const forceFocus = (): void => {
    if (input.current) {
      input.current.focus();
    }
  };

  type onChangeHandleT = (value: string) => void;
  const onChangeHandle: onChangeHandleT = (value) => {
    const regExp = /^[0-9]*$/;
    const filteredValue = value.replace(/-/g, "");

    const typedValue = filteredValue === "" ? "" : parseInt(filteredValue);
    const initLimit = 2147483647;
    const initLimitCondition =
      typeof typedValue === "number" && typedValue > initLimit;

    if (regExp.exec(filteredValue) && !disabled) {
      setValueState(() => {
        if (initLimitCondition) {
          return initLimit;
        }

        return typedValue === "" ? null : typedValue;
      });
    }
  };

  const mutateMediaHandle = useRef(
    _.debounce((value) => mutateMedia(value), 500)
  ).current;

  useEffect(() => {
    return () => {
      mutateMediaHandle.cancel();
    };
  }, []);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }

    mutateMediaHandle(valueState);
  }, [valueState]);

  return (
    <InsightItemWrapper
      onClick={forceFocus}
      label={label}
      disabled={permanentDisabled}
    >
      <StyledInput
        ref={input}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        value={valueState ? valueState : !focus ? "-" : ""}
        disabled={permanentDisabled}
        onChange={(e) => onChangeHandle(e.target.value)}
      />
    </InsightItemWrapper>
  );
};

export default InputColumn;
